import { useCallback } from "react";
import { useNavigation } from "@react-navigation/native";
import Constants from "@lib/utilities/Constants";
import Storage from "@lib/utilities/storage/StorageFunctions";
import {
  saveUserInNexus,
  saveUserProfile,
  uploadDeviceToken,
} from "@lib/utilities/Helpers";
import { POLICY_LISTING_ROUTE } from "../../../src/navigation/NavigationConstants";
import { Platform } from "react-native";

export const useTokenManagement = () => {
  const navigation = useNavigation();

  const saveTokenAndUserDetails = useCallback(async (token: string) => {
    const bearerToken = `Bearer ${token}`;
    Constants.User.ACCESS_TOKEN = bearerToken;
    await Storage.storeData(
      Constants.LocalStoreConstant.ACCESS_TOKEN,
      bearerToken
    );

    await saveUserProfile(bearerToken);
    await saveUserInNexus(bearerToken);
    await uploadDeviceToken(bearerToken);
  }, []);

  const saveTokensAndNavigate = useCallback(
    async (accessToken: string, refreshToken?: string) => {
      if (Platform.OS != "web") {
        Storage.storeData(
          Constants.LocalStoreConstant.REFRESH_TOKEN,
          refreshToken
        );
      }
      await saveTokenAndUserDetails(accessToken);
      navigation.navigate(POLICY_LISTING_ROUTE as never);
    },
    [saveTokenAndUserDetails, navigation]
  );

  return {
    saveTokenAndUserDetails,
    saveTokensAndNavigate,
  };
};
